module.exports = __webpack_public_path__ + "static/media/image.c61700e2.svg";